import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import moment from 'moment';
import PackagesHook from '../../hooks/PackagesHook';

export default function BookingCalendar() {
  const { getPackages } = PackagesHook();

  useEffect(() => {
    document.title = 'Booking Calendar';
    getPackages();
  }, []);

  const packages = useSelector((state) => state.packages.packages);
  const collapsed = useSelector((state) => state.collapsed.collapsed);

  const [currentMonth, setCurrentMonth] = useState(new Date());

  // Normalize dates using moment
  const normalizeDate = (dateString) => {
    const formats = ['YYYY-MM-DD', 'DD-MM-YYYY', 'YYYY-DD-MM','DD/MM/YYYY'];
    const parsedDate = moment(dateString, formats, true);
    return parsedDate.isValid() ? parsedDate.toDate() : null;
  };

  const packageByDate = packages.reduce((acc, data) => {
    const { package_header, departure_flight, sold = 0, total_slots = 0 } = data;

    if (package_header?.toLowerCase().includes('umrah')) {
      const departureDate = departure_flight?.departure_flight_date;

      const normalized = normalizeDate(departureDate);
      if (normalized) {
        const formattedDate = moment(normalized).format('YYYY-MM-DD');
        acc[formattedDate] = (acc[formattedDate] || 0) + (total_slots - sold);
      } else {
        console.warn(`Invalid date format: ${departureDate}`);
      }
    }

    return acc;
  }, {});

  const tileContent = ({ date, view }) => {
    if (view === 'month') {
      const formattedDate = moment(date).format('YYYY-MM-DD');
      const count = packageByDate[formattedDate] || 0;
      return count > 0 ? <span className="badge bg-success ms-2">{count}</span> : null;
    }
  };

  return (
    <div className={`${collapsed ? 'collapsed mt-5 ' : 'main mt-5'}`}>
      <div className="container-fluid bg-none my-0 mt-4">
        <div className="row px-2 mt-5 pt-4">
          <div className="col-md-12 booking_calendar_container data_table p-2 pb-3 new_package">
            <div className="card p-4 border-0">
              <div className="row">
                <div className="d-flex justify-content-between px-1 info_header">
                  <div className="left">
                    <h4 className="mb-3">Booking Calendar</h4>
                  </div>
                </div>
                <hr />
              </div>
              <div className="row my-3 justify-content-center">
                <div className="col-md-10">
                  <Calendar
                    value={currentMonth}
                    onChange={(value) => setCurrentMonth(new Date(value))}
                    tileContent={tileContent}
                    onClickDay={() => null}
                    className="custom_calendar px-2 py-4 border rounded"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
